import storage from './storage';
import browser from './browser';
import util from './util';

// const $ = require('zepto');
const $ = {
  inArray: (element, array, fromIndex = 0) => [].indexOf.call(array, element, fromIndex),
};

const { cookie } = storage;

const infoData = {}; // 存放用户信息
let uin; // uin信息

// 如果cookie里面有uin信息，先提取之
if (cookie.get('uin')) {
  uin = cookie.get('uin');
  // eslint-disable-next-line
  uin = parseInt(uin.replace('o', ''));
  infoData.uin = uin;
} else if (cookie.get('p_uin')) {
  uin = cookie.get('p_uin');
  // eslint-disable-next-line
  uin = parseInt(uin.replace('o', ''));
  infoData.uin = uin;
}

/**
 * Hybrid User class
 * @class
 */
class HybridUser {
  constructor() {
    /**
     * 获取当前登录者的g_tk
     * @property {Function} getToken
     */
    this.getToken = (function () {
      let tmpSkey = null;
      let tmpToken = null;
      return function () {
        const skey = cookie.get('skey') || '';
        let hash = 5381;
        let token = tmpToken;

        if (skey) {
          // 只有缓存中的skey失效时才重新生成gtoken
          if (skey !== tmpSkey) {
            tmpSkey = skey;
            let i = 0;
            const l = skey.length;
            for (; i < l; i += 1) {
              hash += (hash << 5) + skey.charAt(i).charCodeAt();
            }
            tmpToken = hash & 0x7fffffff;
            token = hash & 0x7fffffff;
          }
        } else {
          // 不存在skey时,不需要token
          // 不需要token的时候传空的就好了, null兼容性有问题
          tmpToken = '';
          token = '';
        }

        return token;
      };
    }());
    /**
     * 获取g_tk，优先使用p_skey计算g_tk，跟node的server统一逻辑
     * @property {Function} getPskeyToken
     */
    this.getPskeyToken = (function () {
      let tmpSkey = null;
      let tmpToken = null;
      return function () {
        const skey = cookie.get('p_skey') || cookie.get('skey') || '';
        let hash = 5381;
        let token = tmpToken;

        if (skey) {
          // 只有缓存中的skey失效时才重新生成gtoken
          if (skey !== tmpSkey) {
            tmpSkey = skey;
            let i = 0;
            const l = skey.length;
            for (; i < l; i += 1) {
              hash += (hash << 5) + skey.charAt(i).charCodeAt();
            }
            tmpToken = hash & 0x7fffffff;
            token = hash & 0x7fffffff;
          }
        } else {
          // 不存在skey时,不需要token
          // 不需要token的时候传空的就好了, null兼容性有问题
          tmpToken = '';
          token = '';
        }

        return token;
      };
    }());
  }

  /**
   *  获取用户的 uin
   * @method
   */
  getUin() {
    return infoData.uin;
  }

  /**
   * 设置 uin
   * @param {Number} qq
   * @method
   */
  setUin(qq) {
    uin = qq;
    infoData.uin = qq;
  }

  /**
   * 获取用户的头像
   * @method
   */
  getAvatar(uUin, size, platform) {
    // 先回滚下jack的修改
    const tempPlatform = platform || browser.client || 'qzone';
    let sizes = [30, 50, 100];
    let tempSize = [];
    if (tempPlatform === 'qq') {
      // 限制size大小
      sizes = [40, 100, 140];
      // eslint-disable-next-line no-nested-ternary
      tempSize = size ? (~$.inArray(size, sizes) ? size : 100) : 100;

      return `//q.qlogo.cn/openurl/${uUin}/${uUin}/${tempSize}?rf=qz_hybrid&c=${util
        .base62()
        .encode(`qz_hybrid@${uUin}`)}`;
    }
    // eslint-disable-next-line no-nested-ternary
    tempSize = size ? (~$.inArray(size, sizes) ? size : 50) : 50;

    return `//qlogo${(uUin % 4) + 1}.store.qq.com/qzone/${uUin}/${uUin}/${tempSize}`;
  }
}

export default new HybridUser();
